import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import HomePage from '@/pages/Home';
import ServicesPage from '@/pages/Services';
import { I18nProvider } from '@/i18n/I18nContext';
import '@/App.css';

function App() {
  return (
    <div className="App min-h-screen bg-[#050D17] text-[#F2F5F8]">
      <I18nProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" />
      </I18nProvider>
    </div>
  );
}

export default App;
